module.exports = __webpack_public_path__ + "easyToBeLandlordBanner-c1-qHg4.png";